import {Injectable} from '@angular/core';
import {BaseModelService} from '../base-model.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentsReviewModel extends BaseModelService {

  tableName = 'yu_v3_documents_review';

}
